// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1WKNi","consentsList":"PatientConsents_consentsList__1XgqF","consentsListEmpty":"PatientConsents_consentsListEmpty__2F47T"};